// extracted by mini-css-extract-plugin
export default {"promotionsBlock":"style_promotionsBlock__r2tNX","newsProdBlck":"style_newsProdBlck__irQQ0","name":"style_name__ujcwe","promImg":"style_promImg__56K-I"};